import {
  Switch,
  FormControl,
  FormLabel,
  Stack,
  SimpleGrid,
  Flex,
} from "@chakra-ui/react";

function ClientToggle({ isActive, onToggle }) {
  return (
    <FormControl as={Flex}>
      <FormLabel htmlFor="isChecked" color={"white"}>
        {isActive === true ? "Active:" : "Inactive:"}
      </FormLabel>
      <Switch
        isChecked={isActive}
        name="status"
        onChange={onToggle}
        colorScheme={"green"}
      />
    </FormControl>
  );
}

export default ClientToggle;
